import styled, { css } from 'styled-components';
import { em } from 'polished';
import { Link } from 'react-router-dom';
import { colors, themed, isDefaultThemeMode } from 'core/theme';
import { media } from 'core/layout';

export const StyledNewsItem = styled.li`
  flex: 0 0 ${(5/12) * 100}%;
  margin-bottom: 1em;
  padding-top: 0 !important;

  & > a {
    display: block;
    height: 100%;
  }

  ${media.tablet`
    flex: 1 0 50%;
  `};

  ${media.tabletSmall`
    flex: none;
    width: 100%;
  `};
`;

export const StyledLink = styled(Link)`
  border-bottom: 1px solid ${colors.hairline};
  display: block;
  padding: 0.5em 0.5em 1em 0.5em;
  margin: -0.5em 0 0 -0.5em;
  text-decoration: none;

  & > h5 {
    margin-bottom: 0.5em;
  }

  &:hover > h5 {
    color: ${colors.primary};
  }

  &:visited > h5 {
    color: ${colors.visited};
  }

  ${media.tablet`
    & > h5 {
      font-size: 1em;
      line-height: ${24/16};
    }
  `};

  ${props => !isDefaultThemeMode(props) && css`
    &:hover {
      background-color: ${colors.text};

      & > h5,
      & > small {
        color: ${colors.background};
      }
    }
  `};
`;

const dateColor = (props) => themed(Object.assign({}, colors.darkThemed, {
  light: colors.B54,
}));

export const Date = styled.small`
  color: ${dateColor};
  font-size: ${em(14)};
  line-height: ${18/14};
`;



// WEBPACK FOOTER //
// ./src/modules/NewsSection/components/styled.js